import $ from "jquery";
import "./summaryPage.scss";
import { state } from "../../../core/settings";
import { createPDF } from "../../../core/customFunctions/createPDF";
import { modelForExport, toggleLoad, GetGroup, changeDimmensionRender, camera, CreateImageList, toggleBackWall, toggleLeftWall, toggleRightWall, changeSceneTime } from "../../../core/3d-configurator";

function countVisibleMeshes(model, nameGroup) {
  let visibleCount = 0;

  model.traverse((object) => {
    //console.log(object.name);

    if (nameGroup === "fan" && object.name === nameGroup && object.visible) {
      visibleCount++;
    } else if (
      object.name &&
      object.name.includes(nameGroup) &&
      object.visible &&
      nameGroup !== "fan"
    ) {
      visibleCount++;
    }
  });

  return visibleCount;
}

async function generateSummaryImage() {
  try {
    const originalDayMode = state.dayMode;

    if (!state.dayMode) {
      changeSceneTime("Day");
      state.dayMode = true;
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    const originalWallStates = {
      backWall: state.backWall,
      leftWall: state.leftWall,
      rightWall: state.rightWall
    };
    state.backWall = false;
    state.leftWall = false;
    state.rightWall = false;

    await new Promise(resolve => setTimeout(resolve, 10));

    if (typeof toggleBackWall === 'function') await toggleBackWall(false);
    if (typeof toggleLeftWall === 'function') await toggleLeftWall(false);
    if (typeof toggleRightWall === 'function') await toggleRightWall(false);

    changeDimmensionRender(false);
    await new Promise(resolve => setTimeout(resolve, 100));

    changeDimmensionRender(true);
    await new Promise(resolve => setTimeout(resolve, 300));

    await CreateImageList();

    let renderImages = null;
    if (window.share_RenderImages) {
      renderImages = window.share_RenderImages;
    } else {
      try {
        const module = await import('../../../core/3d-configurator');
        renderImages = module.share_RenderImages;
      } catch (importError) {
        console.log('Could not import share_RenderImages:', importError);
      }
    }

    // Restore original mode
    if (!originalDayMode) {
      changeSceneTime("Night");
      state.dayMode = false;
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    if (renderImages && renderImages.length >= 1) {
      return renderImages[0].src;
    } else {
      return null;
    }
  } catch (error) {
    console.log('Error generating summary image:', error);

    try {
      if (originalWallStates) {
        state.backWall = originalWallStates.backWall;
        state.leftWall = originalWallStates.leftWall;
        state.rightWall = originalWallStates.rightWall;

        if (originalWallStates.backWall) toggleBackWall(true);
        if (originalWallStates.leftWall) toggleLeftWall(true);
        if (originalWallStates.rightWall) toggleRightWall(true);
      }
    } catch (restoreError) {
      console.log('Error restoring walls:', restoreError);
    }

    return null;
  }
}

function hideDimensions() {
  try {
    changeDimmensionRender(false);
  } catch (error) {
    console.log('Could not hide dimensions:', error);
  }
}

export async function summaryPageComponent(container) {

  let environmentToRestore = false;
  const originalDayMode = state.dayMode;

  const originalWallStates = {
    backWall: state.backWall,
    leftWall: state.leftWall,
    rightWall: state.rightWall
  };

  if (!state.dayMode) {
    changeSceneTime("Day");
    state.dayMode = true;
    environmentToRestore = true;
    await new Promise(resolve => setTimeout(resolve, 100));
  }

  const model = state.model ? "LiteShade™" : "TitanCover™";
  const wall =
    [
      state.backWall && "Back Wall",
      state.leftWall && "Left Wall",
      state.rightWall && "Right Wall",
    ]
      .filter(Boolean)
      .join(", ") || "-";
  const roof = state.model ? state.typeLiteShadeRoof : "Louvered";
  const size = `${state.width}' x ${state.length}' x ${state.height}'`;
  const postSize = state.initValuePostSize.includes("6")
    ? `6' x 6'`
    : state.initValuePostSize.includes("8")
      ? `8' x 8'`
      : `4' x 4'`;
  const frameColor = state.colorBody;
  const roofColor = state.colorRoof;

  const recesLight = countVisibleMeshes(modelForExport, "point-light")
    ? `${countVisibleMeshes(modelForExport, "point-light")}`
    : "No";

  const spacing = countVisibleMeshes(modelForExport, "point-light")
    ? state.recessedLighting
    : "-";
  const paramLight = countVisibleMeshes(modelForExport, "LED")
    ? "Yes"
    : "No";
  const fans = countVisibleMeshes(modelForExport, "fan")
    ? `${countVisibleMeshes(modelForExport, "fan")}`
    : "No";
  const heaters = countVisibleMeshes(modelForExport, "ufo")
    ? `${countVisibleMeshes(modelForExport, "ufo")}`
    : "No";

  const screens = countVisibleMeshes(modelForExport, "clone_screen")
    ? `${countVisibleMeshes(modelForExport, "clone_screen")}`
    : "No";
  const pattern = state.patternScreen;
  const color = state.colorScreen;
  const shade = countVisibleMeshes(modelForExport, "clone_shades")
    ? `${countVisibleMeshes(modelForExport, "clone_shades")}`
    : "No";

  const summaryContent = $(`
      <div id="summary-content">
        <div class="sum__page" id="sum-page">
          <h2 class="sum__page__title">Your Pergola Looks Amazing!</h2>
          <div class="sum__page__close" id="sum-close"></div>
    
          <div id="js-summary-image-preview-1">
            <img class="sum__page__img" src="" alt="Loading..."><img/>
          </div>
    
          <ul class="sum__page__main-list">
            <li class="sum__page__main-list__item">
              <h3 class="sum__page__main-list__item__title">Model</h3>
              <div class="sum__page__main-list__item__param">${model}</div>
            </li>
    
            <li class="sum__page__main-list__item">
              <h3 class="sum__page__main-list__item__title">Wall</h3>
              <div class="sum__page__main-list__item__param">${wall}</div>
            </li>
    
            <li class="sum__page__main-list__item">
              <h3 class="sum__page__main-list__item__title">Roof</h3>
              <div class="sum__page__main-list__item__param">${roof}</div>
            </li>
    
            <li class="sum__page__main-list__item">
              <h3 class="sum__page__main-list__item__title">Dimensions</h3>
              <div class="sum__page__main-list__item__param">${size}</div>
            </li>
    
            <li class="sum__page__main-list__item">
              <h3 class="sum__page__main-list__item__title">Post Size</h3>
              <div class="sum__page__main-list__item__param">${postSize}</div>
            </li>
    
            <li class="sum__page__main-list__item">
              <h3 class="sum__page__main-list__item__title">Frame Color</h3>
              <div class="sum__page__main-list__item__param">${frameColor}</div>
            </li>
    
            <li class="sum__page__main-list__item">
              <h3 class="sum__page__main-list__item__title">Roof Color</h3>
              <div class="sum__page__main-list__item__param">${roofColor}</div>
            </li>
          </ul>
    
          <div class="sum__page__electrical-options">
              <h3 class="sum__page__main-list__item__title sum__page__main-list__item__title--el">Electrical Options</h3>
              
              <ul class="sum__page__main-list">
                  <li class="sum__page__main-list__item sum__page__main-list__item--lil">
                   <h3 class="sum__page__main-list__item__title sum__page__main-list__item__title--lil">Recessed Lighting</h3>

                   <div class="sum__page__main-list__item__param sum__page__main-list__item__param--lil">${recesLight}</div>
                 </li>

                  <li class="sum__page__main-list__item sum__page__main-list__item--lil">
                   <h3 class="sum__page__main-list__item__title sum__page__main-list__item__title--lil sum__page__main-list__item__param--color">Spacing</h3>

                   <div class="sum__page__main-list__item__param sum__page__main-list__item__param--lil sum__page__main-list__item__param--color">${spacing}</div>
                 </li>

                ${!state.model ? `
                <li class="sum__page__main-list__item sum__page__main-list__item--lil">
                  <h3 class="sum__page__main-list__item__title sum__page__main-list__item__title--lil">Perimeter lights</h3>
                  <div class="sum__page__main-list__item__param sum__page__main-list__item__param--lil">${paramLight}</div>
                </li>
               ` : ''}

                  <li class="sum__page__main-list__item sum__page__main-list__item--lil">
                   <h3 class="sum__page__main-list__item__title sum__page__main-list__item__title--lil">Fans</h3>

                   <div class="sum__page__main-list__item__param sum__page__main-list__item__param--lil">${fans}</div>
                 </li>

                  <li class="sum__page__main-list__item sum__page__main-list__item--lil">
                   <h3 class="sum__page__main-list__item__title sum__page__main-list__item__title--lil">Heaters</h3>

                   <div class="sum__page__main-list__item__param sum__page__main-list__item__param--lil">${heaters}</div>
                 </li>
              <ul/>
          </div> 
    
          <div class="sum__page__electrical-options">
              <h3 class="sum__page__main-list__item__title sum__page__main-list__item__title--el">Accessories</h3>
              
              <ul class="sum__page__main-list">
                  <li class="sum__page__main-list__item sum__page__main-list__item--lil">
                   <h3 class="sum__page__main-list__item__title sum__page__main-list__item__title--lil">Screens</h3>

                   <div class="sum__page__main-list__item__param sum__page__main-list__item__param--lil">${screens}</div>
                 </li>

                  <li class="sum__page__main-list__item sum__page__main-list__item--lil">
                   <h3 class="sum__page__main-list__item__title sum__page__main-list__item__title--lil sum__page__main-list__item__param--color">Pattern</h3>

                   <div class="sum__page__main-list__item__param sum__page__main-list__item__param--lil sum__page__main-list__item__param--color">${pattern}</div>
                 </li>

                  <li class="sum__page__main-list__item sum__page__main-list__item--lil">
                   <h3 class="sum__page__main-list__item__title sum__page__main-list__item__title--lil sum__page__main-list__item__param--color">Color</h3>

                   <div class="sum__page__main-list__item__param sum__page__main-list__item__param--lil sum__page__main-list__item__param--color">${color}</div>
                 </li>

                  <li class="sum__page__main-list__item sum__page__main-list__item--lil">
                   <h3 class="sum__page__main-list__item__title sum__page__main-list__item__title--lil">Shades</h3>

                   <div class="sum__page__main-list__item__param sum__page__main-list__item__param--lil">${shade}</div>
                 </li>
              <ul/>
          </div> 
    
          <div class="sum__page__buttons">
            <button class="sum__page__buttons__button sum__page__buttons__button--back" id="back-bt">Back To Configurator</button>
            <button class="sum__page__buttons__button sum__page__buttons__button--contact" id="contact-bt">Request Quote</button>
            <button class="sum__page__buttons__button" id="dw-bt">Download PDF</button>
          </div>
        </div>
      </div>
    `);

  const backButton = summaryContent.find("#back-bt");
  const contactButton = summaryContent.find("#contact-bt");
  const downloadButton = summaryContent.find("#dw-bt");

  async function restoreWalls() {
    state.backWall = originalWallStates.backWall;
    state.leftWall = originalWallStates.leftWall;
    state.rightWall = originalWallStates.rightWall;

    if (originalWallStates.backWall && typeof toggleBackWall === 'function') {
      await toggleBackWall(true);
    }
    if (originalWallStates.leftWall && typeof toggleLeftWall === 'function') {
      await toggleLeftWall(true);
    }
    if (originalWallStates.rightWall && typeof toggleRightWall === 'function') {
      await toggleRightWall(true);
    }
  }

  summaryContent.find("#sum-close").on("click", async () => {
    hideDimensions();

    await restoreWalls();

    if (environmentToRestore && !originalDayMode) {
      changeSceneTime("Night");
      state.dayMode = false;
    }

    $("html, body").animate({ scrollTop: 0 }, "fast", () => {
      summaryContent.hide();
      $("body").removeClass("body-overflow-auto");
    });
  });

  backButton.on("click", async () => {
    toggleLoad(true);
    hideDimensions();

    await restoreWalls();

    if (environmentToRestore && !originalDayMode) {
      changeSceneTime("Night");
      state.dayMode = false;
    }

    $("html, body").animate({ scrollTop: 0 }, "fast", () => {
      summaryContent.hide();
      $("body").removeClass("body-overflow-auto");
    });
    toggleLoad(false);
  });

  contactButton.on("click", () => {

    if (typeof window.setSummaryFormAction === 'function') {
      window.setSummaryFormAction('quote');
    } else {
      console.error('setSummaryFormAction not found!');
    }

    document.getElementById('sum-portal').style.display = 'block';
    document.body.classList.remove('body-overflow-auto');
  });

  downloadButton.on("click", async () => {
    try {
      toggleLoad(true);
      const pdfBlob = await createPDF();

      if (pdfBlob) {
        const url = URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `hideaway-pergola-configuration.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        throw new Error('PDF blob is empty');
      }

      toggleLoad(false);
    } catch (error) {
      console.error('>>> PDF download error:', error);
      toggleLoad(false);
    }
  });

  $(container).append(summaryContent);

  setTimeout(async () => {
    try {
      const imageElement = summaryContent.find('.sum__page__img');
      const imageSrc = await generateSummaryImage();

      if (imageSrc) {
        imageElement.attr('src', imageSrc);
        imageElement.attr('alt', 'Pergola configuration');
      } else {
        imageElement.attr('alt', 'Image generation failed');
      }
    } catch (error) {
      const imageElement = summaryContent.find('.sum__page__img');
      imageElement.attr('alt', 'Error loading image');
    }
  }, 100);
}